/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a note
 * @export
 * @interface UpdateNoteRequest
 */
export interface UpdateNoteRequest {
    /**
     * Updated plaintext note content
     * @type {string}
     * @memberof UpdateNoteRequest
     */
    text: string;
}

/**
 * Check if a given object implements the UpdateNoteRequest interface.
 */
export function instanceOfUpdateNoteRequest(value: object): value is UpdateNoteRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function UpdateNoteRequestFromJSON(json: any): UpdateNoteRequest {
    return UpdateNoteRequestFromJSONTyped(json, false);
}

export function UpdateNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function UpdateNoteRequestToJSON(json: any): UpdateNoteRequest {
    return UpdateNoteRequestToJSONTyped(json, false);
}

export function UpdateNoteRequestToJSONTyped(value?: UpdateNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

